import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

// Thin "sending…" progress bar pinned to the TOP of the WhatsApp conversation
// panel (just under the contact header). While a send is in flight a green
// "light" sweeps left→right across a subtle track; it unmounts when the send
// completes. Applies to ALL WhatsApp sends (bound to whatsppSendLoading).
//
// Rendered inside a zero-height overlay wrapper so it never shifts the message
// list — the 3px bar overlays the very top edge of the conversation.

function WhatsappSendingBar({ sending }) {
    if (!sending) return null;
    return (
        <Box sx={{ position: 'relative', height: 0, overflow: 'visible', zIndex: 5 }}>
            <Box
                role="progressbar"
                aria-label="Sending message"
                aria-busy="true"
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '3px',
                    overflow: 'hidden',
                    // Very subtle green track; the moving highlight is the green "light".
                    backgroundColor: 'rgba(0, 167, 111, 0.10)',
                    '@keyframes waSendSweep': {
                        '0%': { transform: 'translateX(-100%)' },
                        '100%': { transform: 'translateX(250%)' },
                    },
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        width: '40%',
                        background: 'linear-gradient(90deg, transparent, #25d366, #00A76F, transparent)',
                        animation: 'waSendSweep 1.2s ease-in-out infinite',
                    },
                    // Reduced motion: a static thin green bar (still conveys "in progress").
                    '@media (prefers-reduced-motion: reduce)': {
                        backgroundColor: '#00A76F',
                        '&::before': { display: 'none' },
                    },
                }}
            />
        </Box>
    );
}

WhatsappSendingBar.propTypes = {
    sending: PropTypes.bool,
};

WhatsappSendingBar.defaultProps = {
    sending: false,
};

export default WhatsappSendingBar;
